module.exports = __webpack_public_path__ + "static/media/particleFilter.18ce9b97.png";